module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_Black.26974866.jpg";